module.exports = __webpack_public_path__ + "img/cover2.a30020b9.jpeg";